import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import { memo } from "react";
import { ASSET_MODAL_HEADER_IN_INFO } from "~/constants/testIDs";
export const AssetLocationName = /*#__PURE__*/ memo((param)=>{
    let { onClick, location } = param;
    return /*#__PURE__*/ _jsxs("p", {
        className: "truncate text-14 font-medium text-grey-11",
        "data-testid": ASSET_MODAL_HEADER_IN_INFO,
        children: [
            "in",
            " ",
            /*#__PURE__*/ _jsx("span", {
                className: classNames("font-medium", !!onClick ? "cursor-pointer hover:underline" : ""),
                onClick: onClick,
                children: location
            })
        ]
    });
});
AssetLocationName.displayName = "AssetLocationName";
